module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'productMananger'
      }
    }
  }, [_vm._v("商品管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑商品")])], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "actForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.actForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "productName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "商品名称",
      "disabled": ""
    },
    model: {
      value: (_vm.actForm.productName),
      callback: function($$v) {
        _vm.$set(_vm.actForm, "productName", $$v)
      },
      expression: "actForm.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": "商品图片",
      "prop": "fileList"
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "src": _vm.actForm.Image
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类",
      "prop": "categoriesName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "品类",
      "disabled": ""
    },
    model: {
      value: (_vm.actForm.categoriesName),
      callback: function($$v) {
        _vm.$set(_vm.actForm, "categoriesName", $$v)
      },
      expression: "actForm.categoriesName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "售货机价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "售货机价格",
      "disabled": ""
    },
    model: {
      value: (_vm.actForm.price),
      callback: function($$v) {
        _vm.$set(_vm.actForm, "price", $$v)
      },
      expression: "actForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "线上价格",
      "prop": "ppwprice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "线上价格",
      "disabled": this.radio == true
    },
    model: {
      value: (_vm.actForm.ppwprice),
      callback: function($$v) {
        _vm.$set(_vm.actForm, "ppwprice", $$v)
      },
      expression: "actForm.ppwprice"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": function($event) {
        _vm.priceAcc()
      }
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("与售货机价格保持一致")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存",
      "prop": "available"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "库存"
    },
    model: {
      value: (_vm.actForm.available),
      callback: function($$v) {
        _vm.$set(_vm.actForm, "available", $$v)
      },
      expression: "actForm.available"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "商品详情",
      "name": "second"
    }
  }, [_c('div', [_c('mavon-editor', {
    ref: "md",
    attrs: {
      "defaultOpen": _vm.defaultData,
      "ishljs": true,
      "toolbars": _vm.toolbars
    },
    on: {
      "change": _vm.changeData,
      "imgAdd": _vm.$imgAdd,
      "imgDel": _vm.$imgDel
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.submitForm('actForm')
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18f4ea8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/product/productModify.vue
// module id = 1037
// module chunks = 2